import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import navigation from "./modules/navigation";
import swatch from "./modules/swatch";
import VuexPersist from "vuex-persist";

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: 'ploouadmincentral',
  storage: localStorage
})

export const store = new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    isLogin : true,
    isLoading : false,
    sessionData : Object,
    token : "",
    validuser: "",
    validpassword:"",
    brandsbytype: [],
    attributesbytype: [],
    premiumusers: []
  },
  getters: {
    username (state) {
      return state.sessionData.username;
    },
    lastname (state) {
      return state.sessionData.lastname;
    },
    userId (state) {
      return state.sessionData.userid;
    },
    email (state) {
      return state.sessionData.email;
    },
    uuid (state) {
      return state.sessionData.uuid;
    },
    status (state) {
      return state.sessionData.status;
    },
    role (state) {
      return state.sessionData.role;
    },
    validuser (state) {
      return state.validuser;
    },
    validpassword (state) {
      return state.validpassword;
    },
    brandsbytype (state) {
      return state.brandsbytype;
    },
    attributesbytype (state) {
      return state.attributesbytype;
    },
    premiumusers (state) {
      return state.premiumusers;
    },
    idcompany (state) {
      return state.sessionData.idcompany;
    }
  },
  mutations:{
    reset (state) {
      // acquire initial state
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    isLogin (state, value) {
      state.isLogin = value
    },
    isLoading (state, value) {
      state.isLoading = value
    },
    setToken (state, token) {
      state.token = token;
      let base64url = token.split('.')[1]
      let base64 = base64url.replace('-', '+').replace('_', '/')
      let claims = JSON.parse(window.atob(base64))
      let sessionData = claims.sub;
      state.sessionData = sessionData;
    },
    setValiduser (state, value) {
      state.validuser = value
    },
    setValidpassword (state, value) {
      state.validpassword = value
    },
    setPremiumusers (state, value) {
      state.premiumusers = value
    }
  },
  actions,
  modules: {
    navigation,
    swatch
  }
});
